import { T } from "@supersig/validate";
export const buildConditionalByReturnValueType = (valueType)=>{
    return T.object({
        type: T.literal("conditional"),
        options: T.arrayOf(T.object({
            //     // If (all, or any) of the conditions are met, return this value
            //     // otherwise, continue to the next condition
            //     operator: T.literalEnum("and", "or"),
            //     conditions: T.arrayOf(
            //       T.object({
            //         name: T.string.optional(),
            //         operator: T.literalEnum("eq", "neq", "c", "gt", "gte", "lt", "lte"),
            //         lhs: nonConditional,
            //         rhs: nonConditional,
            //       })
            //     ),
            // This is the react-query type that we'll use to evaluate
            // and see if this is the correct value
            query: T.any.nullable(),
            value: valueType.nullable()
        }))
    });
};
